import { useDeleteVacancyCompanyCandidateMutation } from "@generated/graphql";
import { IconButton } from "@mui/material";
import { ToastContext, ToastTypeEnum } from "context/toastContext";
import { useContext } from "react";
import DeleteIcon from "assets/icons/DeleteIcon";
import { ConfirmModalContext } from "context/confirmModalContext";
import { parseApolloError } from "helpers/errorsParser";
import { VacancyCompanyCandidatesRefetch } from "../types";

interface DeleteCandidateButtonProps {
  candidateId: string;
  setVacancyCompanyCandidatesRefetch: VacancyCompanyCandidatesRefetch;
}

const DeleteCandidateButton = ({ candidateId, setVacancyCompanyCandidatesRefetch }: DeleteCandidateButtonProps) => {
  const { addToast } = useContext(ToastContext);
  const { handleOpen } = useContext(ConfirmModalContext);
  const [deleteVacancyCompanyCandidate] = useDeleteVacancyCompanyCandidateMutation();

  const handleDeleteCandidate = () => {
    deleteVacancyCompanyCandidate({ variables: { vacancyCompanyCandidateId: candidateId } })
      .then(() => {
        addToast({ type: ToastTypeEnum.SUCCESS });
        setVacancyCompanyCandidatesRefetch?.();
      })
      .catch((e) => parseApolloError(e, { addToast }));
  };

  const onDeleteCandidate = (e: React.MouseEvent) => {
    e.stopPropagation();

    handleOpen({
      title: "Вы уверены, что хотите удалить кандидата из вакансии?",
      actionButtonText: "Удалить",
      handleClick: handleDeleteCandidate,
    });
  };

  return (
    <IconButton onClick={onDeleteCandidate}>
      <DeleteIcon />
    </IconButton>
  );
};

export default DeleteCandidateButton;
